import KfDialog from './kf-dialog.riot';
import { createAction } from 'redux-actions';
export { KfDialog };

export const openSuccessDialog = createAction('@@dialog/OPEN_SUCCESS_DIALOG');
export const openFailedDialog = createAction('@@dialog/OPEN_FAILED_DIALOG');
export const openFailedReloadDialog = createAction('@@dialog/OPEN_FAILED_RELOAD_DIALOG');
export const openInfoDialog = createAction('@@dialog/OPEN_INFO_DIALOG');
export const closeDialog = createAction('@@dialog/CLOSE_DIALOG');

const dialog = {
  show: false,
  message: null,
  status: null,
  reload: false,
};

export default (state = dialog, action) => {
  switch (action.type) {
    case String(openSuccessDialog):
      return {
        ...state,
        show: true,
        message: action.payload,
        status: 'success',
        reload: false,
      };

    case String(openFailedDialog):
      return {
        ...state,
        show: true,
        message: action.payload,
        status: 'failed',
        reload: false,
      };

    case String(openFailedReloadDialog):
      return {
        ...state,
        show: true,
        message: action.payload,
        status: 'failed',
        reload: true,
      };

    case String(openInfoDialog):
      return {
        ...state,
        show: true,
        message: action.payload,
        status: 'info',
        reload: false,
      };

    case String(closeDialog):
      return {
        ...state,
        show: false,
        message: null,
        status: null,
        reload: false,
      };
    default:
      return state;
  }
};